import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import __ from "utils/i18n";
import { PermissionsContext } from "contexts/permissionsContext";
import FlexTable from "components/FlexTable";
import FullTextSearch from "components/FullTextSearch";
import Loader from "components/Loader";
import DashboardPanel from "containers/Dashboard/components/DashboardPanel";
import { EquipmentPanel } from "../EquipmentPanel";
import { getEquipmentsColumns } from "../../_shared/columns";
import { NewEquipmentModal } from "../NewEquipmentModal";
import { Button } from "reactstrap";
import { FirstEquipmentModal } from "../FirstEquipmentModal";
import { HowToModal } from "../HowToModal";
import { DeleteModal } from "../DeleteModal";

export const EquipmentsContent = ({
  data,
  isFetching,
  error,
  reload,
  fetchEquipments,
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const [paymentTerminalId] = useState("");
  const [items, setItems] = useState([]);
  const { subsidiaries } = useSelector((state) => state.login.user) || [];
  const { subsidiaryId, subsidiaryName } = useSelector((state) => state.login.user);
  const subsidiariesList = subsidiaries || [{ subsidiaryId, subsidiaryName }];

  const token = useSelector((state) => state.api.token);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(null);

  const { userPermissions } = useContext(PermissionsContext);
  const isAddEquipmentEnabled = userPermissions?.includes("standalone_action_add");
  const isEditEquipmentEnabled = userPermissions?.includes("standalone_action_edit");
  const isDeleteEquipmentEnabled = userPermissions?.includes('standalone_action_delete');

  const getPaymentTerminal = () => {
    return data.find((payment) => payment.entityId === paymentTerminalId) || {};
  };

  const paymentTerminalData = getPaymentTerminal();

  const handleDeleteClick = (equipment) => {
    setSelectedEquipment(equipment);
    setShowDeleteModal(true);
  };

  const handleSuccess = () => {
    reload();
  };

  return (
    <div
      className={classNames({
        "dashboard-card": true,
        "panel-expanded": showDetails,
      })}
    >
      <DashboardPanel
        expanded={showDetails}
        panelHeading={
          paymentTerminalData.id
            ? `${__("actions.edit")} ${paymentTerminalData.alias}`
            : ''
        }
        hidePanel={() => setShowDetails(false)}
      >
        <EquipmentPanel
          isFetching={isFetching}
          data={paymentTerminalData}
          onSave={() => fetchEquipments({ force: false })}
          onDelete={() => fetchEquipments({ force: false })}
          hidePanel={() => setShowDetails(false)}
          showDetails={showDetails}
          token={token}
        />
      </DashboardPanel>

      <div className="dashboard-card-header">
        <FullTextSearch
          keys={["alias", "serialNumber"]}
          items={data}
          onChange={(items) => setItems(items)}
        />
        {isAddEquipmentEnabled && (
          <NewEquipmentModal
            onSuccess={handleSuccess}
          />
        )}
      </div>

      <div className="dashboard-card-body">
        {isFetching && <Loader />}
        {!isFetching && error && (
          <div className="dashboard-card-message">
            <h3 className="text-danger">{error}</h3>
            <Button color="secondary" onClick={reload}>
              {__("actions.retry")}
            </Button>
          </div>
        )}
        {!items.length && !isFetching && !error && (
          <div className="dashboard-card-message">
            <FirstEquipmentModal />
            <i className="mdi mdi-minus-circle" />
            <h3>{__("dashboard.sections.standalone.whithoutEquipments")}</h3>
            <HowToModal />
          </div>
        )}
        {!isFetching && !error && items.length > 0 && (
          <FlexTable
            data={items}
            columns={getEquipmentsColumns(subsidiariesList, handleDeleteClick, isEditEquipmentEnabled, isDeleteEquipmentEnabled)}
          />
        )}
        {showDeleteModal && (
          <DeleteModal
            id={selectedEquipment.entityId}
            token={token}
            deleteSuccess={() => fetchEquipments({ force: false })}
            showModal={showDeleteModal}
            hideModal={() => setShowDeleteModal(false)}
          />
        )}
      </div>

    </div>

  );
};
